import React from "react";
import Icon from "../../../../../../shared/components/ui/icons/Icon";
import classes from "./ImageDisplayOption.module.css";

const ImageDisplayOption = ({ name, checked, onChange, title, desc, icon, children }) => {
    return (
        <div className={`${classes.ImageDisplayOption} ${checked ? classes.ImageDisplayOptionSelected : ""}`}>
            <label className={classes.OptionRow}>

                <input
                    type="radio"
                    name={name}
                    checked={checked}
                    onChange={onChange}
                    className={classes.Radio}
                />
                {icon && <Icon name={icon} size="20px" className={classes.OptionIcon} />}

                <span className={classes.OptionLabel}>
                    <span className={classes.OptionTitle}>{title}</span>
                    <span className={classes.OptionDesc}>{desc}</span>
                </span>
            </label>
            {children}
        </div>
    );
};

export default ImageDisplayOption;
